export const TimeEntryConfig = {
    // Users can enter time for today and the previous (NUM_DAYS - 1) days.
    // Change this single value to adjust the window (e.g. set to 2).
    NUM_DAYS: 5,
};